import React, { Component, useState } from 'react';
import {
  FormControl, 
  InputLabel,
  Select, 
  MenuItem,
} from "@mui/material";

import { 
  TransformOption2 
} from "@dndModels";

import DandDCharacterUtilities from "@dndUtilities/char_utilities";

interface Props {
  options: TransformOption2[];
  value?: string;
  name: string;
  onChange: (value: string) => void;
  color?: string;
  disabled?: boolean;
}

const char_util = DandDCharacterUtilities.getInstance();


export default function SelectTransformOption2Box({
  options,
  value,
  name,
  onChange,
  color = "",
  disabled = false
}: Props) {
  const renderControl = () => {
    console.log(options);
    return (
      <FormControl variant="outlined" fullWidth>
        <InputLabel htmlFor={`selectInput_${name}`}>{name}</InputLabel>
        <Select
          labelId={`selectInput_${name}`}
          id={`selectInput_${name}`}
          value={value ? value : ""}
          onChange={(event: any) => {
            onChange(event.target.value);
          }}
          fullWidth
          disabled={disabled}
        >
          { options.map((opt: TransformOption2, i: any) => {
            return (<MenuItem key={i} value={opt._id}>{opt.name}{ char_util.renderChallengeRating(opt.challenge_rating) }{ opt.count > 1 ? ` x ${opt.count}` : "" }</MenuItem>);
          })}
        </Select>
      </FormControl>
    );
  }

  if (color !== "") {
    return (
      <div style={{
        border: "1px solid #1C9AEF"
      }}>
        { renderControl() }
      </div>
    );
  } else {
    return renderControl();
  }
}
